import React from 'react';

function SvgEchIconLeft(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = React.useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      {...props}
    >
      <defs>
        <linearGradient
          id={`${iconUuid}_a`}
          x1={66.15}
          y1={-158.62}
          x2={29.61}
          y2={-195.16}
          gradientTransform="translate(108.43 -126.77) rotate(180)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
      </defs>
      <polygon
        fill={`url(#${iconUuid}_a)`}
        stroke={`url(#${iconUuid}_a)`}
        strokeWidth={5}
        points="60.55 86.66 24.12 50.12 60.55 13.58 61.61 14.64 26.24 50.12 61.61 85.6 60.55 86.66"
      />
    </svg>
  );
}
export default SvgEchIconLeft;
